import { secureApi } from './secureApi';

/**
 * Availability grid API — every unit × every night of a short window, for the ops page
 * «التقويم» (tasks/multi-unit-availability-grid.md). Read-only: nothing here can change
 * a night. Ops change availability in the unit calendar, which syncs to Channex from there.
 *
 * Uses the shared `secureApi` instance so the JWT interceptor and the 401 handling are the
 * app's. `preserveBackendError: true` keeps the backend's Arabic 400 message (an unsupported
 * window, a bad filter) instead of the interceptor's generic text — same reason as pricingApi.js.
 */
const KEEP_CODES = { preserveBackendError: true };

const availabilityGridApi = {
  /**
   * @param {object} params { start?, days, ownerId?, building?, status?, bedrooms? }
   *   `start` omitted = today as the SERVER resolves it in the business timezone.
   */
  getGrid: async (params) => {
    const response = await secureApi.get('/api/v1/inventory/grid', { params, ...KEEP_CODES });
    return response.data.data;
  }
};

export default availabilityGridApi;
